module.exports = __webpack_public_path__ + "static/media/fengjie.9d894e8e.png";